module.exports = __webpack_public_path__ + "img/logoAICheckinIntelite.d85f275e.png";